import { useEffect, useState } from 'react';
import Loadable from '@app/utils/Loadable';

// A page that is still loading has no total of its own, so the last loaded page's total stands in for it
export default function useLastResolvedTotal<T>(page: Loadable<PaginatedData<T>>): number {
  const [lastResolvedTotal, setLastResolvedTotal] = useState(0);

  useEffect(() => {
    if (page.isResolved()) {
      setLastResolvedTotal(page.result.totalElements);
    }
  }, [page]);

  return page.isResolved() ? page.result.totalElements : lastResolvedTotal;
}
